import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateConfigService } from './services/translate-config.service';
import { IonicStorageModule } from '@ionic/storage-angular';

import { IMqttServiceOptions, MqttModule } from 'ngx-mqtt';
import { environment as env } from '../environments/environment';

import { EmailComposer } from '@awesome-cordova-plugins/email-composer/ngx';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';

import { PDFGenerator } from '@awesome-cordova-plugins/pdf-generator/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';


import { File } from '@awesome-cordova-plugins/file/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
// imports...

const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
  hostname: env.mqtt.hostname,
  port: env.mqtt.port,
  connectTimeout: env.mqtt.connectTimeout,
  path: env.mqtt.path,
  protocol: env.mqtt.protocol === 'wss' ? 'wss' : 'ws',
};

export function LanguageLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      mode: 'ios',
      rippleEffect: true,
      scrollPadding: false,
      scrollAssist: true,
      animated: true,
      loadingSpinner: 'bubbles',
      keyboardHeight: 300,
      swipeBackEnabled: true,
    }),
    AppRoutingModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: LanguageLoader,
        deps: [HttpClient],
      },
    }),
    MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
  ],
  providers: [
    TranslateConfigService,
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    EmailComposer,
    CallNumber,
    StatusBar,
    PDFGenerator,
    AppVersion,
    File,
    FileOpener,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
